import { type ReactNode, useMemo } from 'react'
import { ConditionTooltip } from 'app/components/ConditionTooltip'
import { type CompanyId, isAdminRole } from '@terros/common'
import { Switch } from '@mantine/core'
import { useRoles, useTranslation } from '@front/model'

type Props = {
  isAdmin: boolean
  onChange: (isAdmin: boolean) => void
  companyId?: CompanyId
}

export const AdminRoleToggle = ({ isAdmin, onChange, companyId }: Props): ReactNode => {
  const { t } = useTranslation()
  const { data: roles } = useRoles({ companyId })

  const adminRole = useMemo(() => roles?.find(isAdminRole), [roles])

  if (!adminRole) return

  return (
    <ConditionTooltip
      refProp='rootRef'
      conditions={[{ active: !adminRole.canAssign, label: t('You do not have permission to assign admins') }]}
    >
      <Switch checked={isAdmin} label={t('Is Admin')} onChange={(e) => onChange(e.currentTarget.checked)} />
    </ConditionTooltip>
  )
}
